const Import = require('../_import_' + process.env.NODE_ENV)
export default [
  {
    path: '/h5/online',
    component: Import('online/index'),
    name: 'onlineIndex',
    meta: { title: '在线公证' }
  },
  {
    path: '/h5/online/position/:type/:code',
    component: Import('online/position'),
    name: 'onlinePosition',
    meta: { title: '在线公证' }
  },
  {
    path: '/h5/online/detail/1/:code',
    component: Import('online/detail'),
    name: 'onlineDetail',
    meta: { title: '在线公证' }
  },
  {
    path: '/h5/online/detail/3/:code',
    component: Import('online/detailProd'),
    name: 'onlineDetailProd',
    meta: { title: '在线公证' }
  }
]



// WEBPACK FOOTER //
// ./src/router/model/online.js